export const saveDoubleDonation = (doubleDonation, formData, recurring) => {
  if (!window.doublethedonation || !doubleDonation || !formData) {
    return;
  }

  const res = doublethedonation.integrations.core.register_donation({
    "360matchpro_public_key": doubleDonation.dd_public_key, // Replace this key with the client's 360MatchPro public key.
    partner_identifier: "GRADU-WmnATnouCJ07NUso",
    campaign: doubleDonation.campaign_names,
    donation_identifier: doubleDonation.payment_id,
    donation_amount: parseFloat(doubleDonation.payment_amount).toFixed(2),
    donor_first_name: formData.get("user[first_name]"),
    donor_last_name: formData.get("user[last_name]"),
    donor_email: formData.get("user[email]"),
    donor_address: {
      zip: formData.get("payment[address][zip]"),
      city: formData.get("payment[address][city]"),
      state: formData.get("payment[address][state]"),
      address1: formData.get("payment[address][address1]"),
      address2: formData.get("payment[address][address2]"),
      country: formData.get("payment[address][country]"),
    },
    donor_phone: formData.get("payment[address][cell_phone]"),
    donation_datetime: doubleDonation.donation_datetime,
    anonymous: formData.get("payment[display_type]") === "anonymous",
    in_memoriam: "",
    athletic: "",
    recurring,
    doublethedonation_company_id: parseInt(doubleDonation.dd_company_id), // Only needed if the donor used the streamlined search field.
    doublethedonation_entered_text: "", // Only needed if the donor used the streamlined search field.
  });
};
